import { ViewGridIcon } from "@heroicons/react/outline";
import * as React from "react";
import type { BadgeProps } from "~/design-system/Badge";
import { Badge } from "~/design-system/Badge";
import { Text } from "~/design-system/Text";

type FloorBadgeProps = Pick<
  BadgeProps,
  "children" | "clickable" | "onRemove" | "shadow" | "size"
>;

function FloorBadge(props: FloorBadgeProps) {
  const { children, ...rest } = props;

  return (
    <Badge leadingIcon={<ViewGridIcon />} maxWidth="full" {...rest}>
      <Text size="inherit" truncate>
        {children}
      </Text>
    </Badge>
  );
}

export { FloorBadge };
